import { render } from "./SpacingInput.vue?vue&type=template&id=173d4080&scoped=true&ts=true"
import script from "./SpacingInput.vue?vue&type=script&lang=ts"
export * from "./SpacingInput.vue?vue&type=script&lang=ts"

import "./SpacingInput.vue?vue&type=style&index=0&id=173d4080&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173d4080"]])

export default __exports__